/* eslint-disable import/no-extraneous-dependencies */
import { initReactI18next } from "react-i18next";
import i18next from "i18next";
import * as config from "./config";
import { ENConfig, PLConfig } from "../../assets/locales";

export const resources = {
  en: ENConfig,
  pl: PLConfig,
};

i18next.use(initReactI18next).init({
  lng: config.defaultLanguage,
  fallbackLng: config.fallbackLanguage,
  ns: config.namespaces,
  defaultNS: config.defaultNameSpace,
  debug: true,
  resources, // Include all language resources
  interpolation: {
    escapeValue: false, // React already handles escaping
  },
});
